module.exports = __webpack_public_path__ + "img/WhySoSad.89022e5a.svg";